var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 44,
    viewBox: "0 0 26 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.542 10.75C19.3322 10.75 21.0491 11.4612 22.315 12.727C23.5808 13.9929 24.292 15.7098 24.292 17.5V40C24.292 40.5967 24.0549 41.169 23.633 41.591C23.211 42.0129 22.6387 42.25 22.042 42.25H4.04199C3.44526 42.25 2.87296 42.0129 2.451 41.591C2.02905 41.169 1.79199 40.5967 1.79199 40V17.5C1.79199 15.7098 2.50315 13.9929 3.76902 12.727C5.03489 11.4612 6.75178 10.75 8.54199 10.75M17.542 10.75H8.54199M17.542 10.75V4C17.542 3.40326 17.3049 2.83097 16.883 2.40901C16.461 1.98705 15.8887 1.75 15.292 1.75H10.792C10.1953 1.75 9.62296 1.98705 9.201 2.40901C8.77905 2.83097 8.54199 3.40326 8.54199 4V10.75M8.54199 26.5H17.542M13.042 22V31",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreams);
export default __webpack_public_path__ + "static/media/Creams.adb93442114bfaa8f7f2cac5829da4c5.svg";
export { ForwardRef as ReactComponent };